import {VehicleForm as VFKit} from '../VehicleForm';

export function DimensionsGroup() {
  return (
    <>
      <VFKit.SimpleNumericField name="dimensions.length" />
      <VFKit.SimpleNumericField name="dimensions.width" />
      <VFKit.SimpleNumericField name="dimensions.height" />
    </>
  );
}
